import authInstance from 'config/axios.config';

export const menuServices = {

  /**
   * Get seller-wise menus (paginated, filtered, grouped by seller)
   */
  getMenus: async ({
    page,
    limit,
    search,
    sellerType,
    sellerStatus,
    serviceType,
    isActive,
    foodType,
    isAvailable,
    isPopular,
    isRecommended,
    isTodaySpecial,
    sortBy,
    sortOrder,
  }) => {
    const params = new URLSearchParams({
      page:           page?.toString()   || '1',
      limit:          limit?.toString()  || '10',
      search:         search             || '',
      sellerType:     sellerType         || '',
      sellerStatus:   sellerStatus       || '',
      serviceType:    serviceType        || '',
      isActive:       isActive           || '',
      foodType:       foodType           || '',
      isAvailable:    isAvailable        || '',
      isPopular:      isPopular          || '',
      isRecommended:  isRecommended      || '',
      isTodaySpecial: isTodaySpecial     || '',
      sortBy:         sortBy             || 'createdAt',
      sortOrder:      sortOrder          || 'desc',
    });

    // Remove empty and "all" values before sending
    for (const [key, value] of [...params.entries()]) {
      if (value === '' || value === 'all') {
        params.delete(key);
      }
    }

    const res = await authInstance.get(
      `/admin/sellers/menu-listing?${params}`
    );

    return res.data;
  },

  /**
   * Get a single menu by its _id.
   * Uses the optional :id path param on the listing endpoint.
   */
  getMenuById: async (menuId) => {
    const res = await authInstance.get(
      `/admin/sellers/menu-listing/${menuId}`
    );
    return res.data;
  },

  /**
   * Approve/disapprove, activate/deactivate, or update images for an item.
   *
   * Item is identified by:
   *   menuId        — menu document _id
   *   subcategoryId — subcategory's subcategoryId ObjectId (ref: Category)
   *   itemSlug      — item's auto-generated slug
   */
  manageItem: async (payload) => {
    const res = await authInstance.patch(
      '/admin/menu/item/manage',
      payload
    );
    return res.data;
  },

  /**
   * Upload an image file to S3 via the admin upload endpoint.
   * Returns { url, key } for the uploaded file.
   */
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const res = await authInstance.post('/admin/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return res.data;
  },

  /**
   * Replace an item's images array via the unified manage endpoint.
   * Called after uploadImage resolves with the S3 key.
   *
   * subcategoryId — ObjectId string from subcategory.subcategoryId
   */
  updateMenuImage: async ({ menuId, subcategoryId, itemSlug, image }) => {
    const res = await authInstance.patch('/admin/menu/item/manage', {
      menuId,
      subcategoryId,   // ✅ was categoryName
      itemSlug,
      images: [image],
    });
    return res.data;
  },

  exportMenus: async (
  filters = {}
) => {

  const params =
    new URLSearchParams();

  Object.entries(filters)
    .forEach(([key, value]) => {

      if (
        value &&
        value !== 'all'
      ) {
        params.append(
          key,
          value
        );
      }
    });

  return authInstance.get(
    `/admin/sellers/menu-listing/export?${params.toString()}`,
    {
      responseType: 'blob',
    }
  );
},
};